// src/shared/dashboard/shell/Icon.tsx
//
// Renders a lucide icon by its kebab-case config name (e.g. "layout-dashboard"),
// falling back to a circle for unknown names.
import * as LucideIcons from "lucide-react";

function kebabToPascal(s: string): string {
  return s.replace(/(^|-)([a-z0-9])/g, (_, __, c) => c.toUpperCase());
}

export function Icon({ name, size = 19 }: { name: string; size?: number }) {
  const Component =
    (LucideIcons as any)[kebabToPascal(name)] ?? LucideIcons.Circle;
  return <Component size={size} strokeWidth={2} />;
}
